import { render, staticRenderFns } from "./BankAccountCreate.vue?vue&type=template&id=f620f346&scoped=true&"
import script from "./BankAccountCreate.vue?vue&type=script&lang=js&"
export * from "./BankAccountCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f620f346",
  null
  
)

export default component.exports